import { GtmEventType } from './gtmEventType';
import {
    buildAiAssetEngagement,
    GA4AiAssetEngagementEvent,
    getInvalidAiAssetEngagementFields,
    isAiAssetEngagementEvent,
    isValidAiAssetEngagement,
    AiAssetSourceEvent,
} from './aiAssetAnalyticsContract';

export class GtmPluginEngagementType extends GtmEventType {
    canHandle(event: AiAssetSourceEvent): boolean {
        return isAiAssetEngagementEvent(event, 'plugin');
    }

    getBody(event: AiAssetSourceEvent): GA4AiAssetEngagementEvent {
        return buildAiAssetEngagement(event, 'plugin');
    }

    isValidEvent(event: GA4AiAssetEngagementEvent): boolean {
        return isValidAiAssetEngagement(event);
    }

    getInvalidEventFields(event: GA4AiAssetEngagementEvent): string[] {
        return getInvalidAiAssetEngagementFields(event);
    }
}
